import './jquery';
import './lib/jquery-ui.js';
import './lib/jquery.bxslider.js';
import './lib/jquery.selectbox.js';
import './lib/jquery.parallax-1.1.3.js';
import './lib/superfish.min.js';
import wwdev from './lib/wwdev.functions';

window.wwdev = wwdev;

$.ajaxSetup({
	headers: {
		'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
	}
});
